import { useQuery } from "app/hooks/graphql.ts";
import { createMutation, createQuery, fields } from "app/utils/graphql.ts";
import { array, object, string, unknown } from "local/deps/superstruct.ts";
import { createRepo, Repo } from "local/repos/mod.ts";
import { ApiKey } from "../types/mod.ts";

/** HELPERS **/

const listQuery = createQuery({
  name: "listUserApiKeys",
  output: array(ApiKey),
  body: `
    query {
      listUserApiKeys {
        ${fields(ApiKey)}
      }
    }
  `,
});

const createMutations = createMutation({
  name: "generateUserApiKey",
  output: ApiKey,
  body: `
    mutation {
      generateUserApiKey {
        ${fields(ApiKey)}
      }
    }
  `,
});

const deleteMutation = createMutation({
  name: "revokeUserApiKey",
  vars: object({
    id: string(),
  }),
  output: unknown(),
  body: `
    mutation ($id: ID!) {
      revokeUserApiKey(id: $id) {
        id
      }
    }
  `,
});

/** MAIN **/

let repo: Repo<ApiKey>;

export function useUserApiKeyRepo() {
  const exec = useQuery();
  if (repo) return repo;

  repo = createRepo({
    create: () => {
      return exec(createMutations);
    },
    update: () => {
      throw new Error("UserApiKeys cannot be updated");
    },
    remove: async (id) => {
      await exec(deleteMutation, { id });
    },
    equals: (a, b) => {
      return (
        a.id === b.id &&
        a.createdAt === b.createdAt &&
        a.vendor === b.vendor &&
        a.secret === b.secret
      );
    },
  });

  const { load, merge } = repo;

  load(async () => {
    merge(await exec(listQuery));
  });

  return repo;
}
